import { render, staticRenderFns } from "./Statistika.vue?vue&type=template&id=24d4a0da&"
import script from "./Statistika.vue?vue&type=script&lang=js&"
export * from "./Statistika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports